import { AuthContext, AuthContextData } from 'contexts/auth-context'
import { useContext } from 'react'

export const useAuth = (authContext: React.Context<AuthContextData> = AuthContext) => {
  const context = useContext(authContext)
  return context
}
